import React, { Component } from 'react';

import { Loading, Alert } from 'Components/Partials';
import { PrimaryButton } from 'Components/Button';
import { FormHandler, Label } from 'Components/Form';
import ReactSelect from 'react-select';

import Survey from 'Services/Api/MainStage/Survey';

class MainStageSurvey extends Component {
    roles = [
        { value: "No7 Advisor", label: "No7 Advisor" },
        { value: "No7 Business Manager", label: "No7 Business Manager" },
        { value: "Store/General Manager", label: "Store/General Manager" },
        { value: "Area Manager", label: "Area Manager" },
        { value: "Head of Stores", label: "Head of Stores" },
        { value: "No7 Field Team", label: "No7 Field Team" },
        { value: "Support Office", label: "Support Office" },
    ];

    survey_questions = [
        { question: "How would you rate the event overall?", answer: "", type: "number" },
        { question: "What is your biggest take-away from the day?", answer: "", type: "text" },
        { question: "How proud are you to work for No7?", answer: "", type: "number" },
        { question: "In a few words, describe how you felt leaving the event.", answer: "", type: "text" },
        { question: "Any other comments?", answer: "", type: "text" },

    ];

    /**
     * @var state
     * @type {{loading: boolean, show: boolean, submission: boolean}}
     */
    state = {
        loading: true,
        submission: false,
        question: 1,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.props.setInitialValues({
            results: [],
        });

        this.fetchSubmission();
    };

    fetchSubmission = async () => {
        const request = await Survey.checkSubmission();

        if (request.success) {
            this.setState({
                submission: request.data.submission,
                loading: false,
            });
        }
    };

    /**
     * @method success
     */
    success = () => {
        this.setState({
            submission: true,
        });
    };

    /**
     * @method updateResults
     * @param {string} question
     * @param {string} answer
     */
    updateResults = (question, answer) => {
        const { handleInput, form } = this.props;

        let new_results = {};

        if (form.results) {
            new_results = {
                ...form.results,
            }
        }

        new_results[question] = answer;

        handleInput('results', new_results);
    }

    /**
     * @method storeSurvey
     * @param {object} form
     * @return {Promise<*>}
     */
    storeSurvey = (form) => {
        const { setAlert, setWorking, currentSession } = this.props;

        if (currentSession.survey_type === 'end-of-event') {
            if (!form.results || Object.keys(form.results).length !== 14) {
                setAlert('error', 'You must provide an answer to every question.', []);
                setWorking(false);
                return null;
            }
        }

        let results = Object.entries(form.results).map((result, key) => {
            return {
                question: result[0].toString(),
                answer: result[1].toString(),
            };
        });

        return Survey.store({
            survey: this.state.survey,
            survey_type: currentSession.survey_type,
            results: results,
        });
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { handleSubmit, resetAlert, working, alert } = this.props;

        const { loading, submission, question } = this.state;

        if (submission) {
            return (
                <div className="text-center">
                    Thank you for your submission
                </div>
            );
        }

        let current_question = this.survey_questions[question -1] ?? null;

        return (
            <div
                className="my-4 p-4 rounded w-full mx-auto text-center text-black my-auto">
                {!loading && !submission && (
                    <form onSubmit={(e) => handleSubmit(e, this.storeSurvey, this.success, true)}>
                        {alert && <Alert {...alert} />}

                        {/*{this.survey_questions.map((question, i) =>  (*/}
                        {/*    <div>*/}
                        {/*        {question.question} <br />*/}

                        {/*        {this.renderSurveyQuestion(question.type, i)}*/}
                        {/*    </div>*/}
                        {/*))}*/}
                        {current_question &&
                            <div>
                                {current_question.question} <br />

                                {this.renderSurveyQuestion(current_question.type, question)}
                            </div>
                        }
                        {/*{question === 1 &&*/}
                        {/*    <div>*/}
                        {/*        What region are you in?*/}
                        {/*        {this.renderSelectBar(0, window.base.regions?.map (e => ({*/}
                        {/*            value: e,*/}
                        {/*            label: e,*/}
                        {/*        })))}*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{question === 2 &&*/}
                        {/*    <div>*/}
                        {/*        What is your role?<br />*/}
                        {/*        {this.renderSelectBar(1, this.roles)}*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{question === 3 &&*/}
                        {/*    <div>*/}
                        {/*        How would you rate the event overall? <br />*/}
                        {/*        {this.renderSurveyScaleNumeric(2)}*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{question === 4 &&*/}
                        {/*    <div>*/}
                        {/*        What is your biggest take-away from the day? <br />*/}
                        {/*        {this.renderTextInput(3)}*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{question === 5 &&*/}
                        {/*    <div>*/}
                        {/*        How proud are you to work for No7? <br />*/}
                        {/*        {this.renderSurveyScaleNumeric(4)}*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{question === 6 &&*/}
                        {/*    <div>*/}
                        {/*        In a few words, describe how you felt leaving the event.  <br />*/}
                        {/*        {this.renderTextInput(5)}*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{question === 7 &&*/}
                        {/*    <div>*/}
                        {/*        Any other comments? <br />*/}
                        {/*        {this.renderTextInput(6)}*/}
                        {/*    </div>*/}
                        {/*}*/}

                        <div className={`mt-4 flex ${question === 1 ? 'justify-end' : 'justify-between'}`}>
                            {question !== 1 && (
                                <PrimaryButton
                                    working={working}
                                    onClick={() => {
                                        resetAlert();
                                        this.setState({ question: + question - 1 });
                                    }}
                                    text="Previous"
                                />
                            )}

                            {question !== this.survey_questions.length && (
                                <PrimaryButton
                                    working={working}
                                    onClick={() => {
                                        resetAlert();
                                        if (this.props.form.results[question - 1] && this.props.form.results[question - 1] !== '') {
                                            this.setState({ question: +question + 1 });
                                        }
                                    }}
                                    type="button"
                                    text="Next"
                                />
                            )}

                            {question === this.survey_questions.length &&
                                <PrimaryButton
                                    working={working}
                                    text="Submit"
                                />
                            }
                        </div>
                    </form>
                )}
            </div>
        );
    }

    /**
     * @method renderSurveyScaleA
     * @return {JSX.Element}
     * @param type
     * @param question_number
     */
    renderSurveyQuestion = (type, question_number) => {
        switch(type) {
            case 'number':
                return this.renderSurveyScaleNumeric(question_number - 1);
            case 'text':
                return this.renderTextInput(question_number - 1);
            default:
                return this.renderSurveyScaleNumeric(question_number -1);
        }
    }
    /**
     * @method renderSurveyScaleA
     * @param {string} question
     * @return {JSX.Element}
     */
    renderSurveyScaleA = (question) => {
        return (
            <div className="p-3 w-max mx-auto">
                {this.renderRadioButton(question, 5, 'excellent')}
                {this.renderRadioButton(question, 4, 'very good')}
                {this.renderRadioButton(question, 3, 'good')}
                {this.renderRadioButton(question, 2, 'not very good')}
                {this.renderRadioButton(question, 1, 'poor')}
            </div>
        );
    }

    /**
     * @method renderSurveyScaleB
     * @param {string} question
     * @return {JSX.Element}
     */
    renderSurveyScaleB = (question) => {
        return (
            <div className="p-3 w-max mx-auto">
                {this.renderRadioButton(question, 5, 'strongly agree')}
                {this.renderRadioButton(question, 4, 'agree')}
                {this.renderRadioButton(question, 3, 'neutral')}
                {this.renderRadioButton(question, 2, 'disagree')}
                {this.renderRadioButton(question, 1, 'strongly disagree')}
            </div>
        );
    }

    /**
     * @method renderSurveyScaleNumeric
     * @param {number} question
     * @return {JSX.Element}
     */
    renderSurveyScaleNumeric = (question) => {
        return (
            <div className="p-3 w-max mx-auto mt-4">
                {this.renderRadioButton(question, 1, 1)}
                {this.renderRadioButton(question, 2, 2)}
                {this.renderRadioButton(question, 3, 3)}
                {this.renderRadioButton(question, 4, 4)}
                {this.renderRadioButton(question, 5, 5)}
                {this.renderRadioButton(question, 6, 6)}
                {this.renderRadioButton(question, 7, 7)}
                {this.renderRadioButton(question, 8, 8)}
                {this.renderRadioButton(question, 9, 9)}
                {this.renderRadioButton(question, 10, 10)}
            </div>
        );
    }

    /**
     * @method renderSurveyScaleBoolean
     * @param {string} question
     * @return {JSX.Element}
     */
    renderSurveyScaleBoolean = (question) => {
        return (
            <div className="p-3 w-max mx-auto">
                {this.renderRadioButton(question, 'Yes', 'Yes')}
                {this.renderRadioButton(question, 'No', 'No')}
            </div>
        );
    }

    /**
     * @method renderRadioButton
     * @param {string} question
     * @param {string} answer
     * @param {string} label
     * @return {JSX.Element}
     */
    renderRadioButton = (question, answer, label) => {
        const { form } = this.props;

        let checked = form.results && form.results[question] ? (form.results[question] === answer) : false;

        return (
            <div className={'flex items-center w-max'}>
                <input
                    type="radio"
                    id={question + '-' + answer}
                    checked={checked}
                    onChange={() => this.updateResults(question, answer)}
                    className={`
                        h-4 w-4 text-indigo-600 transition duration-150 ease-in-out appearance-none rounded-full
                        border hover:border-gray-600 focus:border-indigo-500
                        ${checked ? 'bg-app-blue border-app-blue' : 'border-gray-500'}
                    `}
                />

                <Label label={label} htmlFor={question + '-' + answer} className="mb-0 ml-4" />
            </div>
        )
    }

    /**
     * @method renderSelectBar
     * @param {string} question
     * @param {string} options
     * @return {JSX.Element}
     */
    renderSelectBar = (question, options) => {
        const { form } = this.props;

        let selectedValue = form.results && form.results[question] ? form.results[question] : null;

        return (
            <div className="my-2">
                <ReactSelect
                    value={selectedValue ? options.filter(n => n.value === selectedValue)[0] : null}
                    options={options}
                    onChange={(option) => this.updateResults(question, option.value)}
                    isSearchable={false}
                />
            </div>
        );
    }

    /**
     * @method renderTextInput
     * @param {number} question
     * @return {JSX.Element}
     */
    renderTextInput = (question) => {
        const { form } = this.props;

        let value = form.results && form.results[question] ? form.results[question] : null;

        return (
            <input
                type="text"
                value={value ?? ''}
                onChange={(e) => this.updateResults(question, e.target.value)}
                className="bg-white border-b border-black text-black font-medium mt-4"
            />
        );
    }
};

export default FormHandler(MainStageSurvey);
